import React, { useEffect, useState } from "react";
import axiosClient from "../axios";
import SideBar from "./SideBar";
import {
  Autocomplete,
  FormControl,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
} from "@mui/material";
import { useParams, useNavigate } from "react-router-dom";
import { Edit } from "@mui/icons-material";

const EditVideo = () => {
  const { id } = useParams();

  const [allProvider, setAllProvider] = useState([]);
  const [partnerId, setPartnerId] = useState("");

  const [videoLink, setVideoLink] = useState("");
  const [countryCode, setCountryCode] = useState("");
  const [hitNumber, setHitNumber] = useState(0);
  const [dailyLimit, setDailyLimit] = useState(0);
  const [timeGap, setTimeGap] = useState(10);
  const [allCountry, setAllCountry] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState("");
  console.log("selectedCountry======================>", selectedCountry);

  const [skipStatus, setSkipStatus] = useState({
    isSkip: false,
    timeGap: 0,
  });
  const [isActive, setIsActive] = useState(false);

  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const [triggerValue, setTriggerValue] = useState(0);

  const getSingleVideo = () => {
    axiosClient
      .get(`/singleVideo/${id}`)
      .then((res) => {
        setTriggerValue(res?.data?.response?.triggerpoints);
        setPartnerId(res?.data?.response?.partnerId);
        setVideoLink(res?.data?.response?.videoLink);
        setHitNumber(res?.data?.response?.hitNumber);
        setDailyLimit(res?.data?.response?.dailyLimit);
        setTimeGap(res?.data?.response?.timeGap);
        setSkipStatus(res?.data?.response?.skipStatus);
        setIsActive(res?.data?.response?.isActive);
        setSelectedCountry(res?.data?.response?.country_code);
        setRegionalConfigs(res?.data?.response?.regionalConfigs || []);
        setCountryCode(res?.data?.response?.countryCode);
      })
      .catch((error) => {
        console.log("error", error);
      });
  };

  const getPartner = () => {
    axiosClient
      .get("/partnersList")
      .then((res) => setAllProvider(res.data.response))
      .catch((error) => console.log(error));
  };

  useEffect(() => {
    getPartner();
  }, []);

  let optionsValue = {
    1: "is profiler",
    2: "surveydisqualification",
    3: "surveycomplete",
    4: "task-games complete",
    5: "task-games failed",
    6: "is partner",
    7: "profiler complete",
    8: "125 earning not complete 1hour",
    9: "125 not complete 1 day",
    10: "How to Do Ptc Video",
  };

  const handleEditVideo = () => {
    if (!videoLink || !dailyLimit || !timeGap) {
      alert("Please Fill All The Fields");
      return;
    }
    if (hitNumber < 0 || dailyLimit < 0 || timeGap < 0) {
      alert("Please Enter Positive Value");
      return;
    }

    let data = {
      triggerpoints: triggerValue,
      videoLink: videoLink,
      hitNumber: hitNumber,
      dailyLimit: dailyLimit,
      timeGap: timeGap,
      skipStatus: skipStatus,
      isActive: isActive,
      partnerId: partnerId,
      countryCode: countryCode
    };
    setLoading(true);
    axiosClient
      .post(`/editVideo/${id}`, data)
      .then((res) => {
        setLoading(false);
        alert(res?.data?.message);
        navigate("/allVideo");
      })
      .catch((error) => console.log("error in edit video", error))
      .finally(() => setLoading(false));
  };

  const getAllCountry = () => {
    axiosClient
      .get("/getAllCountry")
      .then((res) => {
        console.log("res of all country", res);
        setAllCountry(res?.data?.response);
      })
      .catch((error) => {
        console.log("Error In Getting All Country...");
      });
  };

  useEffect(() => {
    getAllCountry();
  }, []);

  useEffect(() => {
    getSingleVideo();
  }, []);

  const [regionalConfigs, setRegionalConfigs] = useState([]);
  const [countryConfig, setCountryConfig] = useState({
    country_code: "",
    video_link: "",
  });

  return (
    <>
      <SideBar handleSideBar={true} activeTab={"allVideo"} />
      <div className="screen">
        <div className="video-heading">
          <p>Edit Video</p>
        </div>
        <div className="video-container">
          <div className="video-item">
            <p>Select Trigger Points</p>
            <input
              type="text"
              disabled={true}
              value={optionsValue[triggerValue]}
              className="video-item-input"
            />
          </div>

          <div className="video-item">
            <p>Select Provider</p>
            <Autocomplete
              disablePortal
              sx={{ width: "50%" }}
              disabled={triggerValue != 6 ? true : false}
              value={
                allProvider?.find((item) => item._id === partnerId) || null
              }
              onChange={(event, newValue) => {
                if (newValue) {
                  setPartnerId(newValue._id);
                } else {
                  setPartnerId("");
                }
              }}
              options={allProvider}
              getOptionLabel={(option) => option.name || ""}
              isOptionEqualToValue={(option, value) => option._id === value._id}
              renderInput={(params) => (
                <TextField {...params} label="Provider" />
              )}
            />
          </div>

          <div className="video-item">
            <p>Enter Video Link</p>
            <input
              type="text"
              value={videoLink}
              // disabled={videoLink != "" ? true : false}
              onChange={(e) => setVideoLink(e.target.value)}
              className="video-item-input"
            />
          </div>
          <div className="video-item">
            <p>Enter Hit Number</p>
            <input
              type="Number"
              value={hitNumber}
              onChange={(e) => setHitNumber(Number(e.target.value))}
              className="video-item-input"
              onWheel={(e) => e.target.blur()}
            />
          </div>
          <div className="video-item">
            <p>Enter Daily Limit</p>
            <input
              type="Number"
              value={dailyLimit}
              onChange={(e) => setDailyLimit(Number(e.target.value))}
              className="video-item-input"
              onWheel={(e) => e.target.blur()}
            />
          </div>

          <div className="video-item">
            <p>Select Time Gap</p>
            <input
              type="Number"
              value={timeGap}
              onChange={(e) => setTimeGap(Number(e.target.value))}
              className="video-item-input"
              onWheel={(e) => e.target.blur()}
            />
          </div>

          {/* <div className="video-item">
            <p>Select Country</p>

            <FormControl sx={{ mb: 0, width: "100%" }}>
              <Autocomplete
                id="country-select"
                options={allCountry}
                value={
                  allCountry.find((item) => item.alpha2 === selectedCountry) ||
                  null
                }
                onChange={(event, newValue) => {
                  setSelectedCountry(newValue?.alpha2 || "");
                }}
                getOptionLabel={(option) => option?.name || ""}
                renderInput={(params) => (
                  <TextField {...params} label="Select Country" />
                )}
                slotProps={{
                  popper: {
                    style: { zIndex: 10000 },
                  },
                }}
              />
            </FormControl>
          </div> */}

          <div className="video-item item-regionalConfigs">
            <p>Country</p>
            <FormControl sx={{ mb: 0, width: "300px" }}>
              <Autocomplete
                options={allCountry}
                value={
                  allCountry.find(
                    (item) => item.alpha2 === countryCode
                  ) || null
                }
                onChange={(event, newValue) => {
                  setCountryCode(newValue?.alpha2 || "");
                }}
                getOptionLabel={(option) => option?.name || ""}
                renderInput={(params) => (
                  <TextField {...params} label="Select Country" />
                )}
              />

            </FormControl>

          </div>



          <div className="video-item">
            <p>Skip Status</p>
            <div className="video-time-boolean skip-section">
              <div className="skipStatus">
                <label style={{ fontSize: "16px", fontWeight: "600" }}>
                  Is Skip:
                </label>

                <div className="skipRadio">
                  <label htmlFor="">True</label>
                  <input
                    type="radio"
                    checked={skipStatus?.isSkip == true ? true : false}
                    onChange={() =>
                      setSkipStatus({ ...skipStatus, isSkip: Boolean(true) })
                    }
                  />
                </div>

                <div className="skipRadio">
                  <label htmlFor="">False</label>
                  <input
                    type="radio"
                    checked={skipStatus?.isSkip == false ? true : false}
                    onChange={() =>
                      setSkipStatus({ ...skipStatus, isSkip: Boolean(false) })
                    }
                  />
                </div>
              </div>

              <div className="skipStatus">
                <label style={{ fontSize: "16px", fontWeight: "600" }}>
                  Time Gap:{" "}
                </label>

                <input
                  type="number"
                  disabled={skipStatus?.isSkip == false ? true : false}
                  style={{ padding: "5px 10px", borderRadius: "5px" }}
                  placeholder="Enter Time Gap."
                  value={skipStatus?.timeGap}
                  onChange={(e) =>
                    setSkipStatus({
                      ...skipStatus,
                      timeGap: Number(e.target.value),
                    })
                  }
                />
              </div>
            </div>
          </div>

          <div className="video-item">
            <p>Is Active </p>

            <div className="video-time-boolean">
              <label htmlFor="">True</label>
              <input
                type="radio"
                checked={isActive == true ? true : false}
                onChange={() => setIsActive(Boolean(true))}
              />

              <label htmlFor="">False</label>

              <input
                type="radio"
                checked={isActive == false ? true : false}
                onChange={() => setIsActive(Boolean(false))}
              />
            </div>
          </div>

          <div className="videoitem-submit" onClick={handleEditVideo}>
            Edit
          </div>
        </div>
      </div>
    </>
  );
};

export default EditVideo;
